import React from 'react';
import styled from 'styled-components';
import colors from 'constants/styles/colors';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { zIndex } from 'constants/styles/z-index';
import { NavItems } from './Nav';
import { Link } from 'components/link';
import { PHONE_NUMBER_DISPLAY, PHONE_NUMBER_E164 } from 'constants/index';

const SWrapper = styled.nav`
    position: absolute;
    top: 88px;
    left: 0;
    width: 100%;
    height: 342px;
    z-index: ${zIndex.navigationHeader};
    background: ${colors.gray_90};
    display: grid;
    place-items: center;
`;

const SContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 16px;
`;

interface Props {
    onClick: () => void;
}

export const MobileNav = ({ onClick }: Props) => {
    const { t } = useTranslation();

    return (
        <SWrapper>
            <SContent>
                <NavItems direction="column" gap="26px" onNavigate={onClick} />
                <Link
                    href={`tel:${PHONE_NUMBER_E164}`}
                    title={t('navigation.button')}
                    variant="outlined"
                    aria-label={`${t('navigation.button')}: ${PHONE_NUMBER_DISPLAY}`}
                    onClick={onClick}
                />
            </SContent>
        </SWrapper>
    );
};
